import { render, staticRenderFns } from "./recursive-menu.vue?vue&type=template&id=f6c9ee6c&scoped=true&"
import script from "./recursive-menu.vue?vue&type=script&lang=js&"
export * from "./recursive-menu.vue?vue&type=script&lang=js&"
import style0 from "./recursive-menu.vue?vue&type=style&index=0&id=f6c9ee6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c9ee6c",
  null
  
)

export default component.exports